import { Button } from '@kontentino/ui';
import { ActionButton } from 'app/components/actions/ActionButton';
import { useActions } from 'app/hooks/useActions';
import { usePostsCreateNew } from 'app/modules/posts/hooks/usePostsCreateNew';
import UserPermissionGate from 'components/UserPermissionGate';
import routes from 'constants/routes';
import { UserPermission } from 'constants/userPermission';
import { useUser } from 'modules/user/userSelector';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import APPROVALS_EMPTY_STATE from './icons/approvals.svg';

const ApprovalsEmptyState: FC = () => {
  const { t } = useTranslation();
  const { userActions } = useActions('users');
  const navigate = useNavigate();
  const { isClient } = useUser();
  const { createInspiration } = usePostsCreateNew();

  return (
    <div className="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-y-3 tw-p-4 tw-text-grayscale-100">
      <img src={APPROVALS_EMPTY_STATE} alt="No pending approvals" />
      <p className="tw-text-center tw-text-base tw-font-semibold tw-text-grayscale-180">
        {t('noPendingApprovals')} 🌊
      </p>
      <p className="tw-max-w-xs tw-text-center tw-text-md tw-font-regular tw-text-grayscale-140">
        {t('approvedPostsMoveQuickly')}
      </p>
      <div className="tw-flex tw-flex-col tw-gap-2 md:tw-flex-row">
        <ActionButton
          action={userActions.inviteUser}
          data-name="approvals_empty-state_invite-user-button"
          data-cy="approvals_empty-state_invite-user-button"
          variant="primary"
          size="small"
        >
          {t('inviteYourTeam')}
        </ActionButton>
        {isClient ? (
          <UserPermissionGate
            scopes={[
              UserPermission.INSPIRATION_CREATE,
              UserPermission.INSPIRATION_CREATE_FROM_CALENDAR,
            ]}
          >
            <Button
              variant="secondary"
              size="small"
              onClick={() => createInspiration()}
              data-name="approvals_empty-state_create-inspiration-button"
              data-cy="approvals_empty-state_create-inspiration-button"
            >
              {t('createInspiration')}
            </Button>
          </UserPermissionGate>
        ) : (
          <UserPermissionGate scopes={UserPermission.ACCESS_CALENDAR}>
            <Button
              variant="secondary"
              size="small"
              onClick={() => navigate(routes.POSTS_CALENDAR)}
              data-name="approvals_empty-state_go-to-calendar-button"
              data-cy="approvals_empty-state_go-to-calendar-button"
            >
              {t('goToCalendar')}
            </Button>
          </UserPermissionGate>
        )}
      </div>
    </div>
  );
};

export default ApprovalsEmptyState;
